/**
 * 轻量事件总线
 * ------------------------------------------------------------
 * 作用：让页面/模块之间不直接互相引用，只通过事件通信。
 * 例如：导入确认成功后 emit('content:changed')，教材页监听后自动刷新。
 *
 * 新增事件：在 EVENTS 里加一行，写上注释说明谁发谁听。
 */
const handlers = new Map();

export function on(event, fn) {
  if (!handlers.has(event)) handlers.set(event, new Set());
  handlers.get(event).add(fn);
  return () => off(event, fn);
}

export function off(event, fn) {
  handlers.get(event)?.delete(fn);
}

export function emit(event, payload) {
  const set = handlers.get(event);
  if (!set) return;
  for (const fn of [...set]) {
    try {
      fn(payload);
    } catch (err) {
      console.warn(`[events] 处理器异常: ${event}`, err);
    }
  }
}

export const EVENTS = {
  /** 内容（教材/单元/单词/句子/题目）变更 —— 由导入中心/教材管理发出，列表页监听刷新 */
  CONTENT_CHANGED: 'content:changed',
  /** 学习数据变更（答题、结算） —— 由 records 发出，首页/报告页监听刷新 */
  PROGRESS_CHANGED: 'progress:changed',
  /** 学生信息（切换学生、改名、XP 变化） */
  STUDENT_CHANGED: 'student:changed',
  /** 设置变更（音效/语速/主题等） */
  SETTINGS_CHANGED: 'settings:changed',
  /** 路由导航完成 */
  ROUTE_CHANGED: 'route:changed',
};
